import React from 'react';
import Icon from '../../../components/AppIcon';

const TrustSection = () => {
  const trustSignals = [
    {
      icon: 'Lock',
      title: 'Data Encryption',
      description: 'Bank-level 256-bit SSL encryption protects all your financial information'
    },
    {
      icon: 'Shield',
      title: 'Privacy-First Design',
      description: 'Your data belongs to you. We never sell or share your personal information'
    },
    {
      icon: 'UserCheck',
      title: 'User Control',
      description: 'You decide what data to track and can delete your account anytime'
    },
    {
      icon: 'Eye',
      title: 'Transparent Practices',
      description: 'Clear privacy policy with no hidden data collection or third-party sharing'
    }
  ];

  return (
    <section className="py-12 md:py-16 lg:py-24 bg-gradient-to-br from-secondary/5 via-background to-primary/5">
      <div className="mx-auto px-4 md:px-6 lg:px-24 max-w-7xl">
        <div className="text-center mb-10 md:mb-14 lg:mb-16">
          <div className="inline-flex items-center justify-center w-16 h-16 md:w-20 md:h-20 bg-success/10 rounded-full mb-4 md:mb-6">
            <Icon name="ShieldCheck" size={32} color="var(--color-success)" strokeWidth={2} />
          </div>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-secondary mb-3 md:mb-4">
            Your Financial Data Is Safe & Private
          </h2>
          <p className="text-base md:text-lg text-muted-foreground max-w-2xl mx-auto">
            We take security and privacy seriously. Your trust is our top priority.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {trustSignals?.map((signal, index) => (
            <div
              key={index}
              className="bg-card rounded-xl md:rounded-2xl p-5 md:p-6 text-center hover:shadow-elevation-3 transition-smooth"
            >
              <div className="inline-flex items-center justify-center w-12 h-12 md:w-14 md:h-14 rounded-full bg-success/10 mb-4">
                <Icon name={signal?.icon} size={24} color="var(--color-success)" strokeWidth={2} />
              </div>
              <h3 className="text-base md:text-lg font-heading font-semibold text-card-foreground mb-2">
                {signal?.title}
              </h3>
              <p className="text-sm md:text-base text-muted-foreground leading-relaxed">
                {signal?.description}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-10 md:mt-12 lg:mt-16 text-center">
          <div className="flex flex-wrap items-center justify-center gap-4 md:gap-6 lg:gap-8">
            <div className="flex items-center gap-2">
              <Icon name="CheckCircle2" size={20} color="var(--color-success)" strokeWidth={2.5} />
              <span className="text-sm md:text-base text-muted-foreground font-caption">GDPR Compliant</span>
            </div>
            <div className="flex items-center gap-2">
              <Icon name="CheckCircle2" size={20} color="var(--color-success)" strokeWidth={2.5} />
              <span className="text-sm md:text-base text-muted-foreground font-caption">SOC 2 Certified</span>
            </div>
            <div className="flex items-center gap-2">
              <Icon name="CheckCircle2" size={20} color="var(--color-success)" strokeWidth={2.5} />
              <span className="text-sm md:text-base text-muted-foreground font-caption">Regular Security Audits</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrustSection;